import { useState, useEffect } from "react";

const links = [
  { label: "Processing Options", href: "#processing-options" },
  { label: "Service Area", href: "#service-area" },
  { label: "Services", href: "#services" },
  { label: "Acceptance Locations", href: "#acceptance-facilities" },
  { label: "vs. Regional Agency", href: "#comparison" },
  { label: "FAQ", href: "#faq" },
  { label: "Local Resources", href: "#local-resources" },
];

export default function ThibodauxStickyNav() {
  const [active, setActive] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const offsets = links.map((l) => {
        const el = document.querySelector(l.href);
        if (!el) return { href: l.href, offset: Infinity };
        return { href: l.href, offset: el.getBoundingClientRect().top };
      });
      const visible = offsets.filter((o) => o.offset <= 120);
      if (visible.length) {
        const closest = visible.reduce((a, b) => (a.offset > b.offset ? a : b));
        setActive(closest.href);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="sticky top-[70px] z-40 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <nav className="flex items-center gap-1 overflow-x-auto py-2 scrollbar-hide">
          {links.map((link) => {
            const isActive = active === link.href;
            return (
              <a
                key={link.href}
                href={link.href}
                className={`whitespace-nowrap text-xs font-semibold px-3 py-1.5 rounded-full transition-all ${
                  isActive
                    ? "bg-[#1A365D] text-white"
                    : "text-gray-500 hover:text-[#1A365D] hover:bg-gray-100"
                }`}
              >
                {link.label}
              </a>
            );
          })}
        </nav>
      </div>
    </div>
  );
}